import { L, vocabulary } from '../define.js';
/** D577 slice a — generated from the domain code lists; every vocabulary is typed against its source. */
export const ACCESS_ADMIN_VOCABULARIES = [
    vocabulary('account.rider_registration_reason', '@vello/api-client RIDER_REGISTRATION_REASON_CODES', {
        rider_asked_by_phone: L('A pessoa pediu por telefone', 'The person asked by phone', 'La persona lo pidió por teléfono', 'La persona lo ha chiesto per telefono'),
        rider_asked_in_person: L('A pessoa pediu pessoalmente', 'The person asked in person', 'La persona lo pidió en persona', 'La persona lo ha chiesto di persona'),
        partner_onboarding: L('Cadastro por parceiro', 'Registration through a partner', 'Registro a través de un socio', 'Registrazione tramite un partner'),
        data_correction: L('Correção de dados', 'Data correction', 'Corrección de datos', 'Correzione dei dati'),
        other: L('Outro motivo', 'Other reason', 'Otro motivo', 'Altro motivo'),
    }),
    vocabulary('account.phone_change_reason', '@vello/api-client PHONE_CHANGE_REASON_CODES', {
        phone_lost: L('Telefone perdido ou roubado', 'Phone lost or stolen', 'Teléfono perdido o robado', 'Telefono perso o rubato'),
        phone_new_number: L('Número novo', 'New number', 'Número nuevo', 'Nuovo numero'),
        phone_typo_correction: L('Correção de digitação', 'Typing correction', 'Corrección de digitación', 'Correzione di digitazione'),
        other: L('Outro motivo', 'Other reason', 'Otro motivo', 'Altro motivo'),
    }),
    vocabulary('api.action_outcome', '@vello/api-client ActionOutcome', {
        ok: L('Concluída', 'Completed', 'Completada', 'Completata'),
        failed: L('Falhou', 'Failed', 'Falló', 'Non riuscita'),
    }),
    vocabulary('identity.realm', '@vello/api-client DirectoryRealm', {
        RIDER: L('Passageiro', 'Rider', 'Pasajero', 'Passeggero'),
        DRIVER: L('Motorista', 'Driver', 'Conductor', 'Autista'),
        MERCHANT: L('Lojista', 'Merchant', 'Comercio', 'Esercente'),
        BUSINESS: L('Empresa', 'Business', 'Empresa', 'Azienda'),
    }),
    vocabulary('agent_desktop.assignment_status', '@vello/api-client AgentDesktopAssignmentStatus', {
        assigned: L('Atribuído', 'Assigned', 'Asignado', 'Assegnato'),
        released: L('Liberado', 'Released', 'Liberado', 'Rilasciato'),
    }),
    vocabulary('agent_desktop.action_kind', '@vello/api-client AgentDesktopActionKind', {
        claim: L('Assumir', 'Claim', 'Asumir', 'Prendi in carico'),
        reassign: L('Transferir', 'Transfer', 'Transferir', 'Trasferisci'),
        release: L('Liberar', 'Release', 'Liberar', 'Rilascia'),
    }),
];
//# sourceMappingURL=access-admin.js.map